import React from "react";
import { Link } from "gatsby";

import ArrowNext from "../../../../images/Icons/ArrowNext";
import ArrowPrev from "../../../../images/Icons/ArrowPrev";

const PrevNextNavFooter = (props) => {
  let hideLinks = false;
  if (
    props.appLocation &&
    props.appLocation.hostname === "brandguidelines.toyota.co.nz"
  ) {
    hideLinks = true;
  }
  return (
    <footer id="prev-next-footer">
      <div className="footer-nav-wrap">
        {props.previousText && !hideLinks ? (
          <Link to={props.previousUrl}>
            <div className="label">
              <ArrowPrev />
              {props.previousText}
            </div>
            <div className="section-header">
              <h2 className="ui header">{props.previousHeader}</h2>
            </div>
          </Link>
        ) : null}
      </div>
      <div className="footer-nav-wrap">
        {props.nextText ? (
          <Link to={props.nextUrl}>
            <div className="label">
              {props.nextText}
              <ArrowNext />
            </div>
            <div className="section-header">
              <h2 className="ui header">{props.nextHeader}</h2>
            </div>
          </Link>
        ) : null}
      </div>
    </footer>
  );
};
export default PrevNextNavFooter;
